import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/rush_hour.json";
import fr from "@/locales/fr/puzzle-types/rush_hour.json";

export const RUSH_NS = "puzzle-types/rush_hour";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerRushTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", RUSH_NS)) i18n.addResourceBundle("en", RUSH_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", RUSH_NS)) i18n.addResourceBundle("fr", RUSH_NS, fr, true, true);
}
